<template>
    <div class="app-segment-control">
        <app-radio
            v-for="option in options"
            :key="option.value"
            :size="size"
            v-model="model"
            :label="option.value"
            :name="name"
            use-segment-control
            @input="setModel">
            <slot :option="option">{{ option.title }}</slot>
        </app-radio>
    </div>
</template>

<script>
export default {
    name: 'app-segment-control',
    props: {
        options: {
            type: Array,
            default() {
                return []
            }
        },
        name: String,
        size: String,
        value: {}
    },
    data() {
        return {
            internalValue: null
        }
    },
    computed: {
        tagSize() {
            return this.size
        },
        model: {
            get() {
                return this.internalValue || this.value
            },
            set(val) {
                this.internalValue = val
                this.$emit('input', val)
            }
        }
    },
    methods: {
        setModel(val) {
            this.model = val
        }
    }
}
</script>

<style lang="stylus">
@import '../../stylus/variables'

.app-segment-control
    background: $light-blue
    border-radius: 18px
    border: 1px solid alpha($dark-blue, 0.05)
    display: flex

    > *
        margin: -1px
</style>
